<!--suppress TypeScriptUnresolvedVariable -->
<div class="perm-admin-users-container" *ngIf="isDefined(usersAssignable)">
    <ng-container *appVar="usersAssignable">
        <div fxLayout="row" fxLayoutAlign="center" class="mt-16 mb-24">
            <app-icon name="fal-users"></app-icon>&nbsp;&nbsp;
            {{'All users'|i18n}}
        </div>
        <div fxLayout="row" fxLayoutAlign="end" class="mb-16">
            <button *ngIf="usersAssignable" mat-stroked-button color="primary" class="new-assignment-button"
                    (click)="onClickNewAssignment()">
                <app-icon name="fal-plus-square"></app-icon>&nbsp;&nbsp;
                {{'New assignment'|i18n}}
            </button>
        </div>
        <ng-container *ngIf="usersAssignable; else unassignableUsers">
            <div *ngIf="assignments; else loadingAssignments">
                <app-permission-assignments [readOnly]="false"
                                            [reactiveSubject]="true"
                                            [hideObject]="true"
                                            [assignments]="assignments"
                                            (subjectClick)="onClickSubjectAssignments($event)">
                </app-permission-assignments>
            </div>
        </ng-container>
    </ng-container>
</div>

<ng-template #subjectAssignments let-data>
    <h1 mat-dialog-title *ngIf="data.hint">{{'Permission assignments for {0}'|i18n:data.hint}}</h1>
    <div mat-dialog-content fxLayout="column">
        <app-subject-permissions [subject]="[data.subjectType, data.subjectId]">
        </app-subject-permissions>
    </div>
</ng-template>

<ng-template #newAssignment let-data>
    <h1 mat-dialog-title>{{'New permission assignment on {0}'|i18n:data.object.hint}}</h1>
    <div mat-dialog-content fxLayout="column">
        <app-new-permission-assignment [subjectType]="data.subjectType"
                                       [object]="data.object"
                                       (assignment)="data.assignment = $event"
                                       (valid)="data.valid = $event"
                                       (dirty)="data.dirty = $event">
        </app-new-permission-assignment>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-stroked-button color="primary"
                [disabled]="!data.valid || !data.dirty"
                [mat-dialog-close]="data.assignment">
            <app-icon name="fal-plus-square"></app-icon>&nbsp;&nbsp;
            {{'Add'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #unassignableUsers>
    <div fxLayout="row" fxLayoutAlign="center">
        <span>
            {{'Insufficient permissions to assign permissions on users'|i18n}}
        </span>
    </div>
</ng-template>

<ng-template #loadingAssignments>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-24 mb-16">
        <mat-spinner diameter="20"></mat-spinner>
        <span class="pl-8">{{'Loading permission assignments'|i18n}}...</span>
    </div>
</ng-template>
